import type { ChecklistDoel } from '@fleet/shared';

/**
 * Open the "new plate" mail in the mail client.
 *
 * A `mailto:` and not a send from the server: there is no mail integration, and this
 * way the message ends up in your own Sent items instead of a log nobody reads. With
 * no address configured it opens without a recipient, which is workable.
 *
 * **Apart from `AutoChecklist.tsx`**: a module that exports a function alongside its
 * components breaks fast refresh, so editing the checklist would reload the page
 * instead of refreshing it. See `react-refresh/only-export-components` in
 * `eslint.config.js`.
 */
export function openChecklistMail(doel: Extract<ChecklistDoel, { soort: 'mailto' }>) {
  const q = `subject=${encodeURIComponent(doel.onderwerp)}&body=${encodeURIComponent(doel.tekst)}`;
  window.location.href = `mailto:${doel.naar ?? ''}?${q}`;
}
